module.exports = __webpack_public_path__ + "static/media/no.fd5bf857.png";